const html = require('choo/html');

module.exports = function(state) {
  return html`
    <div class="flex mt-1">
      <label class="text-md" for="ssn-input">
        ${state.translate('ssn')}
      </label>

      <span
        class="question-icon self-center ml-1 cursor-pointer group"
        role="tooltip"
        aria-label="${state.translate('ssnInfo') +
          ' ' +
          state.translate('commaSeperated')}"
      >
        <p class="tooltip">
          ${state.translate('ssnInfo') +
            ' ' +
            state.translate('commaSeperated')}
          >
        </p></span
      >

      <label
        id="ssn-msg"
        class="self-end text-sm text-red mr-1 ml-auto dark:text-red-40
                ${state.ssnError ? '' : 'invisible'}"
        for="ssn-input"
      >
        ${state.translate('invalid')}
      </label>
    </div>

    <input
      id="ssn-input"
      class="w-full border rounded leading-loose px-2 py-1 dark:bg-grey-80 
                ${state.syndisInputs.ssnError ? 'border-red' : ''}"
      type="text"
      autocomplete="off"
      oninput="${ssnChanged}"
      placeholder="${state.translate('ssn')}"
      value="${state.syndisInputs.ssnInput || ''}"
      autocomplete="off"
      data-item="ssn"
    />
  `;

  function ssnChanged(event) {
    event.stopPropagation();
    event.preventDefault();
    removeErrorEffect(event.target);
    state.syndisInputs.ssnError = false;
    state.syndisInputs.ssnInput = event.target.value;
  }

  function removeErrorEffect(target) {
    const item = target.dataset.item;
    const label = document.getElementById(item + '-msg');
    const input = document.getElementById(item + '-input');
    label.classList.add('invisible');
    input.classList.remove('border-red');
  }
};
